import {
  OfficeMissingInfoAdapters,
  type IToOfficeMissingInfoPatchesArgs,
} from '../adapters/OfficeMissingInfo';
import { getUserCredentials } from '../clients/GetUserCredentials';
import { refreshAuthToken } from '../clients/RefreshAuthToken';
import { updateOfficeInfo } from '../clients/UpdateOfficeInfo';
import { updateOfficeProductivity } from '../clients/UpdateOfficeProductivity';
import { updateUserCredentials } from '../clients/UpdateUserCredentials';

/**
 * Writes only the pieces that were asked, in the order Account Information uses: the monolith
 * first, then a token refresh and the credential-service write. The first failure stops the chain;
 * nothing already written is rolled back.
 */
/** `officeId` scopes every write (`x-office`); omitted, the store's selected office is the target. */
const save = async (
  input: IToOfficeMissingInfoPatchesArgs,
  officeId?: string | null,
): Promise<void> => {
  const { usersPatch, productivityPatch, credentialsPatch } =
    OfficeMissingInfoAdapters.toPatches(input);

  if (usersPatch) {
    await updateOfficeInfo(usersPatch, officeId);
  }
  if (productivityPatch) {
    await updateOfficeProductivity(productivityPatch, officeId);
  }
  if (credentialsPatch) {
    await refreshAuthToken();
    await updateUserCredentials(credentialsPatch, officeId);
  }
};

export const OfficeMissingInfoService = {
  save,
  getCredentials: getUserCredentials,
};
